export const resetGeneralInfoStatus = (reset) => {
  return {
    type: 'RESET_GENERAL_INFO_STATUS',
    payload: reset,
  }
}

export const generalInfoError = (error) => {
  return {
    type: 'GENERAL_INFO_ERROR',
    payload: error,
  }
}

export const getGeneralInfo = (data) => {
  return {
    type: 'GET_GENERAL_INFO',
    payload: data,
  }
}

export const setGeneralInfo = (data) => {
  return {
    type: 'SET_GENERAL_INFO',
    payload: data,
  }
}
export const updateGeneralInfo = (data) => {
  return {
    type: 'UPDATE_GENERAL_INFO',
    payload: data,
  }
}

export const deleteGeneralInfo = (data) => {
  return {
    type: 'DELETE_GENERAL_INFO',
    payload: data,
  }
}